export default "__VITE_ASSET__CBH1kfLi__"